// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import DocumentGenerate from "../containers/DocumentGenerate";

class GraphQlDocument extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='imagus_admin' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="GraphQl Documentation"
            IconName="Book"
          />
          <div className="app-panel">
            <div className="app-panel-content">
              <DocumentGenerate endpoint="/graphql/v2/documentation" />
            </div>
          </div>
        </div>
      </UserAuth>
    );
  }
}

export default GraphQlDocument;
